const SiteGAID = {
    nova88: 'G-C65Q6MT91B',
    viva88: 'G-LLSCMGSDY6',
    bong88: 'G-FR64WVHR9J',
    pica88: 'G-19LTEDPKZ6',
    id8899: 'G-C65Q6MT91B',
    ibcbet: 'G-XECG1ZYH7S',
    bettha88: 'G-SHWZGD89D3',
    taraplays: 'G-J0MJ3MXLEF',
};

const GTM_ID = 'GTM-PPT7NL2T';

const getGtmData = (siteName) => {
    const siteNameLowerCase = siteName?.toLowerCase();
    const dataLayer = JSON.stringify([{ SiteName: siteName }, { GAID: SiteGAID[siteNameLowerCase] }]);
    return `dataLayer =${dataLayer};
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`;
};

export {
    SiteGAID,
    GTM_ID,
    getGtmData,
};
